/* "Goes with" blocks: sections/lw-goes-with.liquid (Limewash) and sections/mlp-goes-with.liquid (Modern Lime Paint). Data: data-src (assets/lw-goes-with.json or assets/mlp-goes-with.json).
   Single-color products key by handle; the Color Collection keys by the selected color and re-draws on on:variant:change. */
(() => {
  const root = document.querySelector('[data-lw-gw]');
  if (!root || root.dataset.lwGwInit) return;
  root.dataset.lwGwInit = '1';
  const list = root.querySelector('[data-lw-gw-list]');
  // Tracking tag: Limewash block has no data-source (stays 'lw-goes-with'); Modern Lime Paint block sets 'mlp-goes-with'.
  const SRC_TAG = root.dataset.source || 'lw-goes-with';
  const routesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  let DATA = null;

  function draw(color) {
    const entry = DATA && color && DATA.colors[color];
    if (!entry) { root.hidden = true; list.innerHTML = ''; return; }
    root.dataset.color = color;
    root.querySelectorAll('[data-lw-gw-color]').forEach(el => { el.textContent = color; });
    const room = root.dataset.roomLink !== 'false';
    list.innerHTML = entry.pairs.map(p => {
      const url = `${routesRoot}products/${encodeURIComponent(p.handle)}`.replace('//', '/');
      return `<li class="lw-gw__card">
  <a class="lw-gw__sw" href="${url}" style="background-color:${esc(p.hex)}" role="img" aria-label="${esc(p.name)} swatch" tabindex="-1"></a>
  <p class="lw-gw__role">${esc(p.role)}</p>
  <a class="lw-gw__name" href="${url}">${esc(p.name)}<span class="lw-gw__line">Thrive Botanical Paint</span></a>
  <p class="lw-gw__why">${esc(p.why)}</p>
  <div class="lw-gw__acts">
    <button type="button" class="lw-gw__add" data-lw-gw-add data-variant-id="${+p.jar}" data-name="${esc(p.name)}" aria-label="Add ${esc(p.name)} sample jar, $5">Add sample · $5</button>
    ${room ? `<a class="lw-gw__room" href="${url}?ref=${encodeURIComponent(SRC_TAG)}#room-preview">See it in a room</a>` : ''}
  </div>
</li>`;
    }).join('');
    root.hidden = false;
  }

  let toastT;
  function toast(msg) { const t = root.querySelector('.lw-gw__toast'); if (!t) return; t.textContent = msg; t.hidden = false; clearTimeout(toastT); toastT = setTimeout(() => { t.hidden = true; }, 2600); }
  // Same cart flow as the samples page and the Thrive room preview.
  const sectionsParam = () => { const d = document.querySelector('cart-drawer'); let s = 'cart-icon-bubble';
    if (d && d.closest('.shopify-section')) s += ',' + d.closest('.shopify-section').id.replace('shopify-section-', ''); return s; };
  async function add(btn) {
    const id = +btn.dataset.variantId; if (!id || btn.getAttribute('aria-busy') === 'true') return;
    const open = root.dataset.openDrawer === 'true';
    btn.setAttribute('aria-busy', 'true');
    try {
      const r = await fetch(`${routesRoot}cart/add.js?ymqcartopen=${open}`, { method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id, quantity: 1, properties: { _source: SRC_TAG } }], sections: sectionsParam(), sections_url: location.pathname }) });
      const data = await r.json();
      if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to your cart');
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
      btn.classList.add('is-added');
      const cart = await fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } }).then(x => x.json());
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart, variantId: id } }));
      document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
      const ymq = !!document.querySelector('script[src*="ymq-cart-drawer"]');
      if (open && !ymq) document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open', { detail: { opener: btn } }));
      else toast(`${btn.dataset.name} sample jar added to your cart`);
    } catch (e) {
      toast(e.message || 'Could not add to your cart');
      document.dispatchEvent(new CustomEvent('on:cart:error', { bubbles: true, detail: { error: e.message } }));
    } finally { btn.removeAttribute('aria-busy'); }
  }
  root.addEventListener('click', e => { const b = e.target.closest('[data-lw-gw-add]'); if (b && root.contains(b)) add(b); });

  fetch(root.dataset.src).then(r => r.json()).then(d => {
    DATA = d;
    let color = root.dataset.color;
    if (root.dataset.mode === 'product') color = d.products[root.dataset.handle] || color;
    draw(color);
    if (root.dataset.mode === 'collection') {
      const idx = +root.dataset.optionIndex || 0;
      document.addEventListener('on:variant:change', e => {
        const v = e.detail && e.detail.variant; if (!v || !v.options) return;
        const c = v.options[idx]; if (c !== root.dataset.color || root.hidden) draw(c);
      });
    }
  }).catch(() => { root.hidden = true; });
})();
